export function BrandMark({
  compact = false,
  name = 'JDH Kitchen',
}: {
  compact?: boolean
  name?: string
}) {
  return (
    <span className="flex min-w-0 items-center gap-2.5" aria-label={name}>
      <img src="/icons/icon.svg" alt="" className="size-8 shrink-0" />
      {!compact && (
        <span className="truncate font-display text-lg font-semibold tracking-tight text-ink">
          {name}
        </span>
      )}
    </span>
  )
}
